import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import palette from './palette';

const ScrollbarStyles = createGlobalStyle`
  html, body, body * { scrollbar-color: transparent transparent; }
  html::-webkit-scrollbar-track, body::-webkit-scrollbar-track, body *::-webkit-scrollbar-track { background: transparent; }
  html::-webkit-scrollbar-thumb, body::-webkit-scrollbar-thumb, body *::-webkit-scrollbar-thumb { background: transparent !important; border-color: transparent !important; }
  html.aidose-is-scrolling, body.aidose-is-scrolling, body .aidose-is-scrolling { scrollbar-color: ${palette.muted} transparent; }
  html.aidose-is-scrolling::-webkit-scrollbar-thumb,
  body.aidose-is-scrolling::-webkit-scrollbar-thumb,
  body .aidose-is-scrolling::-webkit-scrollbar-thumb { background: ${palette.muted} !important; }
  @media (forced-colors: active) {
    html, body, body * { scrollbar-color: auto; }
    html::-webkit-scrollbar-thumb, body::-webkit-scrollbar-thumb, body *::-webkit-scrollbar-thumb { background: CanvasText !important; }
  }
`;

const GlobalScrollbars = () => {
  useEffect(() => {
    const timers = new Map();
    const onScroll = (event) => {
      const element = event.target === document ? document.documentElement : event.target;
      if (!(element instanceof Element)) return;
      element.classList.add('aidose-is-scrolling');
      clearTimeout(timers.get(element));
      timers.set(
        element,
        setTimeout(() => {
          element.classList.remove('aidose-is-scrolling');
          timers.delete(element);
        }, 700),
      );
    };
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    return () => {
      document.removeEventListener('scroll', onScroll, true);
      timers.forEach((timer, element) => {
        clearTimeout(timer);
        element.classList.remove('aidose-is-scrolling');
      });
    };
  }, []);
  return <ScrollbarStyles />;
};
export default GlobalScrollbars;
